import { useCallback } from "react";

import { useUserTriggeredModalsHistoryState } from "../history/use-modal-history-states";
import { useModalHistoryStepCounter } from "../history/use-modal-history-step-counter";

export const useModalSetOperations = () => {
  const [, , pushTemporaryModalsState] = useUserTriggeredModalsHistoryState();
  const countStepsToReachModalState = useModalHistoryStepCounter();

  const setUserTriggeredModals = useCallback(
    (expectedModalIds: string[]) => {
      const stepsToGoBack = countStepsToReachModalState(expectedModalIds);

      if (stepsToGoBack !== null) {
        window.history.go(-stepsToGoBack);
      } else {
        pushTemporaryModalsState((temporaryModalsState) => temporaryModalsState.filter((entry) => expectedModalIds.includes(entry.id)));
      }
    },
    [countStepsToReachModalState, pushTemporaryModalsState],
  );

  return { setUserTriggeredModals };
};
